import ToolsView from "../ToolsView.vue";
import ProductQuoteList from "../Pages/ProductQuoteList.vue"
import ProductQuoteEditor from "../Pages/ProductQuoteEditor.vue"
import RedirectionsList from "../Pages/RedirectionsList.vue";
import RedirectionsEditor from "../Pages/RedirectionsEditor.vue";
import BiolinkPage from '../Pages/BiolinkPage.vue'
import AnnouncementBarList from '../Pages/AnnouncementBarList.vue'
import AnnouncementBarForm from '../Pages/AnnouncementBarForm.vue'
import CouponsList from '../Pages/CouponsList'
import CouponEditor from '../Pages/CouponEditor'

const routes = [
  {
    path: '/herramientas',
    component: ToolsView,
    plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
    name: 'tools',
    children: [
      {
        path: 'cotizaciones',
        name: 'tools-quotes-list',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: ProductQuoteList
      },
      {
        path: 'cotizaciones/crear',
        name: 'tools-quotes-form',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: ProductQuoteEditor
      },
      {
        path: 'cotizaciones/:id/editar',
        name: 'tools-quotes-edit',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: ProductQuoteEditor
      },
      {
        path: 'redirecciones',
        name: 'tools-redirections-list',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: RedirectionsList
      },
      {
        path: 'redirecciones/crear',
        name: 'tools-redirections-create',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: RedirectionsEditor
      },
      {
        path: 'redirecciones/:id/editar',
        name: 'tools-redirections-edit',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: RedirectionsEditor
      },
      {
        path: 'biolink',
        name: 'tools-biolink',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: BiolinkPage,
      },
      {
        path: 'barra-de-anuncios',
        name: 'tools-announcement-bar-list',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: AnnouncementBarList
      },
      {
        path: 'barra-de-anuncios/crear',
        name: 'tools-announcement-bar-create',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: AnnouncementBarForm
      },
      {
        path: 'barra-de-anuncios/:id/editar',
        name: 'tools-announcement-bar-edit',
        plan: ['PRO', 'BUSINESS', 'ENTERPRISE'],
        component: AnnouncementBarForm
      },
      {
        path: 'cupones',
        name: 'tools-coupons-list',
        plan: ['ALL'],
        component: CouponsList
      },
      {
        path: 'cupones/crear',
        name: 'tools-coupons-create',
        plan: ['ALL'],
        component: CouponEditor
      },
      {
        path: 'cupones/:id/editar',
        name: 'tools-coupons-edit',
        plan: ['ALL'],
        component: CouponEditor
      }
    ]
  },
]

export default routes
